import { graphql } from "../graphql";
import mutation from "./mutation.gql";
import { FetchResult } from "@apollo/client";
import { graphqlExtractGraphqlErrors } from "@/v2/util/graphql-extract-graphql-errors";
import { IRepoErrors } from "../errors";
import { graphqlRemapValidationErrors } from "@/v2/util/graphql-remap-validation-errors";

export interface IDeleteTenantRequest {
  id: string;
  organizationId: string;
}

export async function deleteTenant(
  request: IDeleteTenantRequest
): Promise<boolean> {
  let response: FetchResult<any, Record<string, any>, Record<string, any>>;
  const errors: IRepoErrors<ValidationErrors> = {};

  try {
    response = await graphql.mutate({
      mutation,
      variables: {
        tenantId: request.id,
        organizationId: request.organizationId,
      },
    });
  } catch (error) {
    errors.networkError = true;
    throw new DeleteTenantError(errors);
  }

  if (response.errors) {
    errors.graphqlError = graphqlExtractGraphqlErrors(response);
    errors.validationError = graphqlRemapValidationErrors(response);

    throw new DeleteTenantError(errors);
  }

  return response.data.deleteTenant;
}

export class DeleteTenantError extends Error {
  errors: IRepoErrors<ValidationErrors>;

  constructor(errors: IRepoErrors<ValidationErrors>) {
    super("Error in repo: DeleteTenantError");
    this.errors = errors;
    this.name = this.constructor.name;
  }
}

type ValidationErrors = {};
